<script>
  // This trivial component is for rapid, temporary in-browwer
  // inspection of data elements.
  export let javascript;
</script>

<pre style="font-size:1.6vh">{JSON.stringify(javascript, null, 2)}</pre>
